import { isDevMode } from '@angular/core';
import { Route } from '@angular/router';
import { SplUiComingSoonFeature } from './coming-soon.feature';

export const splUiComingSoonFeatureRoute: Route = {
  path: '**',
  component: SplUiComingSoonFeature,
  canMatch: [() => !isDevMode()],
};
